import { StyleSheet } from 'aphrodite';
import * as React from 'react';
import { InputGroupAddon, InputGroupInput, InputGroupText, InputGroupV2 } from '../../../components-v2/InputGroup';
import { darkGrayFontColor } from '../../../styles/colors';

const MAX_DIGITS = 12;

const styleSheet = StyleSheet.create({
	currencySign: {
		color: darkGrayFontColor,
	},
});

const formatCents = (cents: number) =>
	(cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const centsFromDigits = (text: string) => {
	const digits = text.replace(/\D/g, '').replace(/^0+/, '').slice(0, MAX_DIGITS);
	return digits ? Number(digits) : null;
};

type Props = Omit<React.ComponentProps<typeof InputGroupInput>, 'value' | 'onChange' | 'type' | 'inputMode'> & {
	value: number | null | undefined;
	onValueChange: (value: number | null) => void;
};

export const CurrencyInput = ({ value, onValueChange, ...props }: Props) => {
	const emit = (cents: number | null) => onValueChange(cents === null ? null : cents / 100);

	return (
		<InputGroupV2>
			<InputGroupAddon align='inlineStart'>
				<InputGroupText styles={[styleSheet.currencySign]}>$</InputGroupText>
			</InputGroupAddon>
			<InputGroupInput
				placeholder='0.00'
				{...props}
				type='text'
				inputMode='numeric'
				value={value == null ? '' : formatCents(Math.round(value * 100))}
				onChange={e => emit(centsFromDigits(e.target.value))}
				onPaste={e => {
					const pasted = Number.parseFloat(e.clipboardData.getData('text').replace(/[^0-9.]/g, ''));
					if (Number.isFinite(pasted)) {
						e.preventDefault();
						emit(Math.round(pasted * 100));
					}
				}}
			/>
		</InputGroupV2>
	);
};
